// extracted by mini-css-extract-plugin
module.exports = {"textDivider":"OrDivider_textDivider__9sF7A","default":"OrDivider_default__yXqlg","secondary":"OrDivider_secondary__v9br1"};